<div class="edit-page">
  <div class="visitor">
    <button class="close" (click)="close()">
      <img class="cross-icon" src="icons/profile-close.svg" />
    </button>
    <span class="visitor-txt">Edit FamilyCode</span>
  </div>

  <p class="form-header">Enter family code to search members</p>

  <input
    type="text"
    class="ac-input-control"
    placeholder="Enter 12-digit family code"
    maxlength="12"
    [(ngModel)]="searchFamilyCode"
    (ngModelChange)="onFamilyCodeChange($event)"
  />

  <p class="form-header" *ngIf="filterData.length > 0">
    Select a name from members
  </p>

  <select
    class="ac-input-control"
    [(ngModel)]="selectedMemberCode"
    *ngIf="filterData.length > 0"
  >
    <option value="" disabled selected>Select a name</option>
    <option *ngFor="let m of filterData" [value]="m.memberCode">
      {{ m.fullName }}
    </option>
  </select>

  <div class="action-row">
    <button class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button
      class="ac-primary-btn"
      (click)="continue()"
      [disabled]="!selectedMemberCode"
    >
      Update
    </button>
  </div>
</div>